import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { RouterModule } from "@angular/router";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { AuthGuard } from "app/guards/auth.guard";
import { HighchartsChartModule } from "highcharts-angular";
import { ChartsComponent } from "./charts/charts.component";

const routes = [
    {
        path: "charts",
        component: ChartsComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [ChartsComponent],
    imports: [
        RouterModule.forChild(routes),
        FormsModule,
        TranslateModule,
        FuseSharedModule,
        FuseWidgetModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSlideToggleModule,
        HighchartsChartModule,
    ],
    exports: [ChartsComponent],
})
export class ChartsModule {}
